import { connect } from 'react-redux'
import SubValuation from './SubValuation'

import componentDidMount from './Handlers/componentDidMount'
import componentWillUnmount from './Handlers/componentWillUnmount'
import onCloseSubValuationModal from './Handlers/onCloseSubValuationModal'
import onCloseNotesModal from './Handlers/onCloseNotesModal'

const mapStateToProps = (state) => ({
  subValuation: state.screens.SubValuation.subValuation,
  activeTab: state.screens.SubValuation.activeTab,
  subValuationModal: state.screens.SubValuation.subValuationModal,
  notesModal: state.screens.SubValuation.notesModal,
})

const actionCreators = {
  componentDidMount,
  componentWillUnmount,
  onCloseSubValuationModal,
  onCloseNotesModal,
}

export default connect(mapStateToProps, actionCreators)(SubValuation)
